import { TableColumnsType } from "antd";

export type ExpendedPurchaseRow = {
  asin: string;
  productTitle: string;
  sku: string;
  quantity: number;
  cogs: number;
};

export type PurchaseRow = {
  key: string;
  poNumber: string;
  status: string;
  incomeTerms: string;
  poDate: string;
  estCompletion: string;
  actCompletion: string;
  destination: string;
  products: ExpendedPurchaseRow[];
};

export const getColor = (status: string) => {
  switch (status) {
    case "Open":
      return "#5295E0";
    case "Cancelled":
    case "Requested":
      return "#FE5858";
    case "Waiting for payments":
      return "#C8A857";
    case "Ongoing":
    case "Closed":
      return "#80C67A";
  }
};

export const expendedPurchaseColumns: TableColumnsType<ExpendedPurchaseRow> = [
  { title: "ASIN", dataIndex: "asin", key: "asin" },
  { title: "Product Title", dataIndex: "productTitle", key: "title" },
  { title: "SKU", dataIndex: "sku", key: "sku" },
  { title: "Quantity", dataIndex: "quantity", key: "qty" },
  {
    title: "COGS",
    dataIndex: "cogs",
    key: "cogs",
  },
];

export const purchaseData: PurchaseRow[] = [
  {
    key: "73291",
    poNumber: "73291",
    status: "Open",
    incomeTerms: "EXW",
    poDate: "01.01.2024",
    estCompletion: "23.10.2024",
    actCompletion: "01.01.2024",
    destination: "Wales, UK, 90 Orange St, EC1A 1AH",
    products: [
      {
        asin: "B0D5MNJWR9",
        productTitle: "Product A",
        sku: "KJG85903G",
        quantity: 332,
        cogs: 8750,
      },
      {
        asin: "B0D5MNJW7",
        productTitle: "Product B",
        sku: "KJG85903G",
        quantity: 332,
        cogs: 8750,
      },
    ],
  },

  {
    key: "73293",
    poNumber: "73293",
    status: "Cancelled",
    incomeTerms: "EXW",
    poDate: "01.01.2024",
    estCompletion: "23.10.2024",
    actCompletion: "01.01.2024",
    destination: "Wales, UK, 90 Orange St, EC1A 1AH",
    products: [],
  },

  {
    key: "73294",
    poNumber: "73294",
    status: "Ongoing",
    incomeTerms: "EXW",
    poDate: "01.01.2024",
    estCompletion: "23.10.2024",
    actCompletion: "01.01.2024",
    destination: "Wales, UK, 90 Orange St, EC1A 1AH",
    products: [
      {
        asin: "B0D5MNJsR9",
        productTitle: "Product A",
        sku: "KJG85903G",
        quantity: 332,
        cogs: 8750,
      },
      {
        asin: "B0D5xNJW7",
        productTitle: "Product B",
        sku: "KJG85903G",
        quantity: 332,
        cogs: 8750,
      },
    ],
  },
];
